export const menuItems = [
  {
    label: 'Product',
    items: [
      {
        label: 'Browse SKUs',
        routerLink: '/products/browse-skus'
      },
      {
        label: 'Social Proof',
        routerLink: '/products/social-proof'
      },
      {
        label: 'Product Exposure',
        routerLink: '/products/product-exposure'
      },
      {
        label: 'Social Proof Reporting',
        routerLink: '/products/social-proof-reporting'
      },
      {
        label: 'Product Exposure Reporting',
        routerLink: '/products/product-exposure-reporting'
      }
    ]
  },
  {
    label: 'Sales',
    items: [
      {
        label: 'Sales Dashboard',
        routerLink: '/sales/sales-dashboard'
      },
      {
        label: 'Sales Detailed',
        routerLink: '/sales/sales-detailed'
      },
      {
        label: 'Category Sales',
        routerLink: '/sales/category-sales'
      },
      {
        label: 'Retails Sales',
        routerLink: '/sales/retail-sales'
      },
      {
        label: 'Sales Forecast',
        routerLink: '/sales/sales-forecast'
      }
    ]
  },
  {
    label: 'Stock',
    items: [
      {
        label: 'Purchase Order',
        routerLink: '/stock/purchase-order'
      },
      {
        label: 'Stock Details',
        routerLink: '/stock/stock-details'
      },
      {
        label: 'Consignment',
        routerLink: '/stock/consignment'
      }
    ]
  },
  {
    label: 'Claims',
    routerLink: '/claims'
  },
  {
    label: 'Rebates',
    items: [
      {
        label: 'Sell In',
        routerLink: '/rebates/sell-in'
      },
      {
        label: 'Sell Through',
        routerLink: '/rebates/sell-through'
      },
      {
        label: 'Sell Reporting',
        routerLink: '/rebates/sell-reporting'
      }
    ]
  },
  {
    label: 'Admin',
    items: [
      {
        label: 'User Management',
        routerLink: '/admin/user-management'
      }
    ]
  },
];
